import * as React from "react";

const SVGComponent = (props) => {
  
  return  (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 5.53476C5 5.23942 5.25584 5 5.57143 5H12.4286C12.7442 5 13 5.23942 13 5.53476V6.60428C13 6.89962 12.7442 7.13904 12.4286 7.13904C12.113 7.13904 11.8571 6.89962 11.8571 6.60428V6.06952H9.57143V13.9305H10.1429C10.4585 13.9305 10.7143 14.1699 10.7143 14.4652C10.7143 14.7606 10.4585 15 10.1429 15H7.85714C7.54155 15 7.28571 14.7606 7.28571 14.4652C7.28571 14.1699 7.54155 13.9305 7.85714 13.9305H8.42857V6.06952H6.14286V6.60428C6.14286 6.89962 5.88702 7.13904 5.57143 7.13904C5.25584 7.13904 5 6.89962 5 6.60428V5.53476Z"
      fill={props.color || "#4F4F4F"}
    />
  </svg>
)};

export default SVGComponent;
